import React from "react";
import Footer from "./Footer/Footer";
import Navbar from "./Navbar/Navbar";

const ThalassemiaDetails = () => {
  return (
    <>
      <Navbar />
      <div className="max-w-[1140px] mx-auto w-full p-5">
        <h2 className="w-[max-content] md:text-[22px] text-[14px] py-[10px] px-[60px] text-white bg-primary rounded-full font-[700] my-5 mx-auto">
          থ্যালাসেমিয়া বিস্তারিতঃ
        </h2>
        <div className="text-black text-[15px] space-y-5">
          <p className="">
            <span className="text-primary font-[700]"> লক্ষ্য ও উদ্দেশ্যঃ</span>{" "}
            থ্যালাসেমিয়া রোগিদের নির্দিষ্ট সময় অন্তর অন্তর রক্ত গ্রহণ করতে
            হয়। কারো প্রতিমাসে, অনেকের প্রায় দুই মাস তিন মাস পরপর রক্তের
            প্রয়োজন হয়। এতে তাদের সবসময়ই পরবর্তী রক্তদাতার খোঁজে
            দুশ্চিন্তাগ্রস্ত থাকতে হয়। আর্থিক ও মানষিক চাপ পরিবারের সদস্যদেরও
            অকৃত্রিম হাসি বিলীন করে দেয়। আমরা রক্তবন্ধুর মাধ্যমে তাদের তথ্যগুলো
            সংগ্রহ করতে চাই এবং প্রতিটি রোগিকে কিছু নির্দিষ্ট সংখ্যক আগ্রহী
            ব্লাড ডোনার দিয়ে যতোদূর সম্ভব চিন্তামুক্ত রাখার সামান্য উদ্যোগ গ্রহণ
            করেছি।
          </p>
          <p>
            সরকার এই রোগিদের বিভিন্নভাবে সহযোগিতা করার সর্বাত্মক চেষ্টা চালিয়ে
            যাচ্ছে। এছাড়াও বাংলাদেশ সরকার ২০২৮ সালের মধ্যে নতুন করে থ্যালাসেমিয়া
            আক্রান্তের প্রতিরোধে কাজ করে যাচ্ছে। রক্তবন্ধু সহ বিভিন্ন রক্তদানের
            সংগঠন থ্যালাসেমিয়া রোধে করণীয় এবং সচেতনতামূলক তথ্য সামাজিক যোগাযোগ
            মাধ্যমগুলোতে অনলাইনে এবং অফলাইনে অনবরত প্রচার করে যাচ্ছে। রক্ত
            বিষয়ক, থ্যালাসেমিয়া নিয়ে বিভিন্নপ্রকার তথ্য দিয়ে স্বেচ্ছাসেবীদের
            সার্বক্ষণিক সহযোগিতা করে যাচ্ছেন যাদের কথা না বললেই নয়- “রক্তদানের
            অপেক্ষায় বাংলাদেশ” প্লাটফর্ম এর সুব্রত দেব ও মো. নজরুল ইসলাম।
          </p>
          <p>
            এই থ্যালাসেমিয়া রোগিদের সমৃদ্ধ তথ্যভান্ডার দিয়ে আমরা আমাদের
            রাষ্ট্রকে তথা বাংলাদেশকে সহযোগিতা করতে চাই। কেননা আমরাই বাংলাদেশ।
            ক্যাম্পেইনটি সফল করতে আপনাদের সকলের সহযোগিতা নিরন্তর কাম্য।
          </p>
          <p>
            আপনি যদি ইতিপূর্বে RoktoBondhu.com এ ডোনার হিসেবে রেজিস্ট্রেশন করে
            থাকেন তবে থ্যালাসেমিয়া ক্যাটাগরিতে রেজিস্ট্রেশন ফরমে “হ্যাঁ”
            টিকচিহ্ন ক্লিক করে পূরণ করুন। যদি রক্তবন্ধুতে আপনি নতুন ডোনার হয়ে
            থাকেন, তবে “না” টিক দিয়ে ফরম পূরণ ও রেজিস্ট্রেশন করুন। (ফরম দেখলেই
            বুঝতে পারবেন)
          </p>
          <p>
            প্রতিবার রক্তদানের পর মেনু থেকে লগইন করে তারিখ আপডেট করতে ভুলবেন না।
          </p>

          <p>
            পুরাতন কেউ পাসওয়ার্ড ভুলে গেলে যোগাযোগ করুন। পাশাপাশি আর কোন তথ্য
            জানার থাকলে কিংবা আমাদের জন্য পরামর্শ থাকলে নির্দ্বিধায় জানাতে
            পারেন।
            <br />✆ 01778951824 ✆ 01521551306
          </p>
          <p className="font-[700]">আমরা রক্তবন্ধু, রক্তের সম্পর্ক গড়ি।</p>
          <p>
            আমাদের ফেসবুক গ্রুপঃ
            <br />
            <a
              target={"_blank"}
              rel="noopener noreferrer"
              href="https://www.facebook.com/groups/roktobondhu/"
              className="text-blue-500"
            >
              "রক্তবন্ধু"
            </a>
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ThalassemiaDetails;
